import React from "react";
import { Button, Card, Col, Row } from "antd/lib/index";
import { Field, FieldArray } from "formik";
import uuid from "uuid/v4";
import { DescripcionComponent, TituloComponent } from "../FormHelpers";

const CustomCasillaArray = ({ actividadIndex, etapaIndex, values }) => {
  const ref = values.etapas[etapaIndex].actividades[actividadIndex]
    .casillas || [
    {
      tituloCasilla: "Titulo Casilla",
      descripcionCasilla: "Descripcion casilla"
    }
  ];

  return (
    <FieldArray
      name={`etapas.${etapaIndex}.actividades.${actividadIndex}.casillas`}
      render={helpers => (
        <Card style={{ background: "#F3E5F5" }}>
          {ref.map((casilla, casillaIndex) => (
            <Row key={casillaIndex} type="flex" align="middle">
              <Col span={22}>
                <div>{`casilla número ${casillaIndex + 1}`}</div>
                <Field
                  name={`etapas.${etapaIndex}.actividades.${actividadIndex}.casillas.${casillaIndex}.tituloCasilla`}
                  component={TituloComponent}
                />
                <Field
                  name={`etapas.${etapaIndex}.actividades.${actividadIndex}.casillas.${casillaIndex}.descripcionCasilla`}
                  component={DescripcionComponent}
                />
              </Col>

              <Col span={2}>
                <Button
                  type="button"
                  onClick={() => helpers.remove(casillaIndex)}
                >
                  -
                </Button>
              </Col>
            </Row>
          ))}
          <Button type="button" onClick={() => helpers.push({ key: uuid() })}>
            +
          </Button>
        </Card>
      )}
    />
  );
};

export default CustomCasillaArray;
